import React, { Component } from "react";
import IntlMessages from "util/IntlMessages";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";

import { LOGOUT_USER } from "constants/actionTypes";
import { createRestrictedAction } from "util/actionCreators";

let UserInfo = class UserInfo extends Component {
  handleLogout() {
    this.props.createRestrictedAction(null, LOGOUT_USER, null, null, () => {
      window.localStorage.removeItem("token");
      this.props.history.push("/");
    });
  }

  render() {
    const name = window.localStorage.getItem("name");
    const isOwner = window.localStorage.getItem("is_owner");
    return (
      <div>
        <div className="user-profile">
          <img
            className="user-avatar border-0 size-40"
            src="http://via.placeholder.com/150x150"
            alt="User"
          />
          <div className="user-detail ml-2">
            <h4 className="user-name mb-0">{name}</h4>
          </div>
        </div>
        <NavLink className="dropdown-item" to="/app/settings">
          <i className="zmdi zmdi-settings zmdi-hc-fw mr-1" />
          Settings
        </NavLink>
        <NavLink className="dropdown-item" to="/app/settings/user">
          <i className="zmdi zmdi-account zmdi-hc-fw mr-1" />
          User Settings
        </NavLink>
        {isOwner === "true" && (
          <NavLink className="dropdown-item" to="/app/settings/smtp">
            <i className="zmdi zmdi-email zmdi-hc-fw mr-1" />
            Email Settings
          </NavLink>
        )}
        <a
          className="dropdown-item"
          href="#"
          onClick={this.handleLogout.bind(this)}
        >
          <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-1" />
          <IntlMessages id="popup.logout" />
        </a>
      </div>
    );
  }
};

UserInfo = connect(null, { createRestrictedAction })(UserInfo);

export default withRouter(UserInfo);



// WEBPACK FOOTER //
// ./components/UserInfo/index.js